"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("../listeners/focusStylesListener");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ShareButton = _interopRequireDefault(require("../decorators/ShareButton"));

var _setupStyledComponents = require("../listeners/setupStyledComponents");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _TabIndex = require("../utils/TabIndex");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  cursor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(0, _setupStyledComponents.setupStyledComponents)();

var UIClickableCore = function UIClickableCore(props) {
  var autoFocus = props.autoFocus,
      buttonRef = props.buttonRef,
      className = props.className,
      __cursor = props.cursor,
      disabled = props.disabled,
      onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      tabIndex = props.tabIndex,
      Tag = props.tagName,
      rest = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "buttonRef", "className", "cursor", "disabled", "onClick", "onKeyDown", "tabIndex", "tagName"]);
  (0, _react.useEffect)(function () {
    if (autoFocus) buttonRef.current.focus();
  }, [autoFocus, buttonRef]);

  var handleKeyDown = function handleKeyDown(evt) {
    var key = evt.key,
        target = evt.target;
    if (onKeyDown) onKeyDown(evt); // Ignore keydown events that bubbled up

    if (target !== buttonRef.current) return; // Simulate click on Enter/Spacebar, to emulate button behavior

    if (key === 'Enter' || key === ' ') {
      if (disabled) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }

      if (onClick) onClick(evt);

      if (key === ' ') {
        evt.preventDefault(); // Prevent page from scrolling (#3575)
      }
    }
  };

  var handleClick = function handleClick(evt) {
    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    if (onClick) onClick(evt);
  };

  return _react.default.createElement(Tag, (0, _extends2.default)({}, rest, {
    "aria-disabled": disabled,
    className: (0, _classnames.default)('private-clickable', className),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: buttonRef,
    tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex, null)
  }));
};

UIClickableCore.displayName = 'UIClickable';
var UIClickable = (0, _styledComponents.default)(UIClickableCore).withConfig({
  displayName: "UIClickable",
  componentId: "sc-1q4mald-0"
})(_templateObject(), function (_ref) {
  var cursor = _ref.cursor,
      disabled = _ref.disabled;
  return disabled ? 'not-allowed' : cursor;
});
UIClickable.displayName = 'Styled(UIClickable)';
UIClickable.propTypes = {
  autoFocus: _propTypes.default.bool,
  buttonRef: _refObject.default,
  cursor: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  tagName: _propTypes.default.string.isRequired
};
UIClickable.defaultProps = {
  cursor: 'pointer',
  role: 'button',
  tagName: 'div'
};

var _default = (0, _ShareButton.default)(UIClickable);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/button/UIClickable.js
// module id = 97
// module chunks = 5 6 7